import React from 'react';
import './LoaderFullPage.scss';
import {Loader} from "./index";

const LoaderFullPage = () => {
  return (
    <div className='LoaderBackground'>
      <Loader size={100} light={false} />
    </div>
  )
};

export default LoaderFullPage;
